import { Typography } from '@mui/material';
import { useAppSelector } from 'app/hooks';

import { disciplinaInfoSelector } from '#modules/disciplinas/redux/disciplinaInfoSlice';

import { BoxInfo } from './styles';

export function PlanoEnsinoBibliografiaComplementar() {
  const disciplina = useAppSelector(disciplinaInfoSelector.disciplina);

  if (disciplina == null) return <></>;

  return (
    <BoxInfo id="bibliografia-complementar">
      <header>
        <Typography>BIBLIOGRAFIA COMPLEMENTAR</Typography>
      </header>

      <div dangerouslySetInnerHTML={{ __html: disciplina.bibliografiaComplementar }} />
    </BoxInfo>
  );
}
